import * as R from 'ramda';

export default function EditPmDocumentDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  loaderService,
  ssDialogService,
  pmDataService,
  newRecommendedChangesDialog,
  pmSharedModelService,
) {
  const vm = this;

  vm.newDocument = R.clone(vm.document);

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleEditDocumentFormSubmit = _handleEditDocumentFormSubmit;

  _activate();

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleEditDocumentFormSubmit() {
    if ($scope.editPmDocumentForm.$valid) {
      // Set the impact analysis date on assessment object
      loaderService.showViewLoader = true;
      pmDataService.savePolicyDocument(vm.newDocument).then(savePolicyDocumentResponse => {
        loaderService.showViewLoader = false;
        const savedDocument = savePolicyDocumentResponse.data;
        if (!savedDocument.policyDocumentId) {
          alerts.error('An error occurred while saving the Document.');
        } else {
          vm.document = savedDocument;
          alerts.success('The Document has been saved successfully.');
          _closeDialog();
          $rootScope.$broadcast('refreshPMDocuments');
          if (vm.newDocument.policyDocumentId === 0) {
            _getChangedSections().then(() => {
              _checkForNewRecommendations();
            });
          }
        }
      });
    }
  }

  function _checkForNewRecommendations() {
    if (vm.combinedNewRecommendedChanges && vm.combinedNewRecommendedChanges.length > 0) {
      _showNewRecommendedChangesDialog({
        newChanges: vm.combinedNewRecommendedChanges,
        changedIds: pmSharedModelService.changedSections,
        isNew: true,
        changesAreRecommended: true,
      });
    }
  }

  function _showNewRecommendedChangesDialog(locals) {
    ssDialogService.dialogs.pm.newRecommendedChangesDialog = ssDialogService.alert(
      newRecommendedChangesDialog.getOptions(null, locals),
    );
    return ssDialogService.show(ssDialogService.dialogs.pm.newRecommendedChangesDialog);
  }

  function _getChangedSections() {
    loaderService.showViewLoader = true;
    return pmDataService.getChangedSections(vm.document.policyDocumentId).then(result => {
      loaderService.showViewLoader = false;
      pmSharedModelService.flattenedActiveDocumentSections = [];
      if (vm.document) {
        vm.document.policyDocumentSections.forEach(section => {
          pmSharedModelService.flattenedActiveDocumentSections = [
            ...pmSharedModelService.flattenedActiveDocumentSections,
            ..._getFlattenedChildrenSections(section),
          ];
        });
      }
      pmSharedModelService.generateTokenizedTextAndBreadcrumbs(result.data);
      pmSharedModelService.changedSections = result.data;
      vm.combinedNewRecommendedChanges = pmSharedModelService.getCombinedChangesFromChangeArrays(result.data);
    });
  }

  function _getFlattenedChildrenSections(section) {
    let flattenedSections = [];
    const tempSection = {
      ...section,
      policyDocumentSectionChildren: undefined,
    };

    flattenedSections.push(tempSection);
    if (section.policyDocumentSectionChildren && section.policyDocumentSectionChildren.length) {
      section.policyDocumentSectionChildren.forEach(childSection => {
        flattenedSections = [...flattenedSections, ..._getFlattenedChildrenSections(childSection)];
      });
    }

    return flattenedSections;
  }

  function _activate() {}

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.pm.editPmDocumentDialog);
  }
}

EditPmDocumentDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',

  'alerts',
  'loaderService',
  'ssDialogService',
  'pmDataService',
  'newRecommendedChangesDialog',
  'pmSharedModelService',
];
